import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { sendEvent } from '../../shared/search-event';
import theme from '../../../assets/stylesheets/_settings.global.scss';
import KeywordResultsContext, { reducer, defaultState } from './keyword-results-components/context';
import WiresMentioning from './keyword-results-components/wires-mentioning';
import TopKeywords from './keyword-results-components/top-keywords';
import LogoSeparator from '../shared/logo-separator';
import TopContributors from './keyword-results-components/top-contributors';

const Columnar = styled.div`
  padding-top: ${props => (props.theme.isDesktop ? 49 : 25)}px;

  & section.sidebar > article:first-child {
    margin-top: 0;
  }
`;

export default function SearchResultsKeyword({ keyword }) {
  const isMobile = useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` });
  const isDesktop = useMediaQuery({ query: `(min-width: ${theme.breakpointLargeMax})` });
  const [st, dispatch] = React.useReducer(reducer, defaultState);

  React.useEffect(() => {
    (async () => sendEvent())();
  }, []);

  const className = isDesktop || isMobile ? 'columnar' : 'columnar no-sidebar';

  return (
    <ThemeProvider theme={{ ...theme, isDesktop }}>
      <KeywordResultsContext.Provider value={{ state: st, dispatch }}>
        <React.Fragment>
          <Columnar className={className}>
            <section className="content">
              {!isDesktop && (
                <React.Fragment>
                  <TopContributors keyword={keyword} />
                  <TopKeywords keyword={keyword} />
                </React.Fragment>
              )}
              <WiresMentioning keyword={keyword} />
              {!!(st.wiresMentioning.length) && (
                <LogoSeparator animate={st.loadingWiresMentioning === 'more'} />
              )}
            </section>
            {isDesktop && (
              <section className="sidebar">
                <TopContributors keyword={keyword} />
                <TopKeywords keyword={keyword} />
              </section>
            )}
          </Columnar>
        </React.Fragment>
      </KeywordResultsContext.Provider>
    </ThemeProvider>
  );
}

SearchResultsKeyword.propTypes = {
  keyword: PropTypes.shape({
    value: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};
